/*
创建者 魏强(2018.1.24)
限时特价 title
*/
<template>
  <div class="dundun-bargain-title">
    <div class="title"><img src="//static.kxymall.com/images/gdo-bargain.png"></div>
    <div class="time">
      <div class="countdown" id="countdown">
        <span class="hours">{{ String(h).length>=2 ? h :'0'+h }}</span>
        <span class="minutes">{{ String(m).length>=2 ? m : '0'+m }}</span>
        <span class="seconds">{{ String(s).length>=2 ? s :'0'+s }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['h', 'm', 's'],
  data() {
    return {

    }
  }
}
</script>
<style scoped>
#countdown span {
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// title.vue?c6266380